export default __webpack_public_path__ + "static/tcofs-ew-wallpaper-1920x1200-4cb49e27ef762dd1d3715238a07217b4.jpg";